import AuthorPage from '../../../components/AuthorPage/AuthorPage';
import { buildPrimaryAuthorPage } from '../../../util/buildPrimaryAuthorPage';
import { ResearchLayout } from '../[[...slug]]';

const { getStaticProps, getStaticPaths, Page } = await buildPrimaryAuthorPage({
    site: 'RESEARCH',
    LayoutComponent: ResearchLayout,
    ContentComponent: AuthorPage,
    menuPropName: 'submenu',
    hasStickyNav: true,
});

export { getStaticProps, getStaticPaths };

export default Page;
